export default __webpack_public_path__ + "static/media/moon.ee1a77e0.svg";